import { render, staticRenderFns } from "./PublicOrganizationParticipationPage.vue?vue&type=template&id=36eaf66a&scoped=true"
import script from "./PublicOrganizationParticipationPage.vue?vue&type=script&lang=js"
export * from "./PublicOrganizationParticipationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36eaf66a",
  null
  
)

export default component.exports